import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Paper, CircularProgress } from '@mui/material';
import FormCampanha from '../../components/Campanhas/FormCampanha';
import { criarCampanha, obterCampanha, atualizarCampanha } from '../../services/campanhaService';

const CriarEditarCampanhaPage = () => {
  const [campanha, setCampanha] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      const fetchCampanha = async () => {
        try {
          setLoading(true);
          const data = await obterCampanha(id);
          setCampanha(data);
        } catch (error) {
          console.error('Erro ao buscar campanha:', error);
          setError('Não foi possível carregar os dados da campanha. Por favor, tente novamente.');
        } finally {
          setLoading(false);
        }
      };

      fetchCampanha();
    }
  }, [id, isEditMode]);

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      if (isEditMode) {
        await atualizarCampanha(id, formData);
      } else {
        await criarCampanha(formData);
      }
      navigate('/campanhas');
    } catch (error) {
      console.error('Erro ao salvar campanha:', error);
      setError('Ocorreu um erro ao salvar a campanha. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {isEditMode ? 'Editar Campanha' : 'Criar Nova Campanha'}
      </Typography>
      <FormCampanha 
        onSubmit={handleSubmit} 
        campanhaInicial={campanha || {}}
      />
    </Paper>
  );
};

export default CriarEditarCampanhaPage;